// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3v9an","signatureBlock":"Footer_signatureBlock__3IGXp","signature":"Footer_signature__3yTP-"};